<template>
  <div>
    <div v-if="isCheckoutType" class="flex py-rem px-5 border-b border-gray-200">
      <div class="flex-1">
        <span class="ota-p16 font-semibold" v-text="$t('Loyalty.Webshop.Cart.YourOrder')" />
      </div>
      <div
        v-if="cart.length"
        class="flex items-center"
      >
        <button class="text-blue-400 ota-p12 focus:outline-none" @click="$emit('edit')" v-text="$t('Loyalty.Webshop.Cart.EditCart')" />
      </div>
    </div>
    <div v-else class="bg-purple-400 py-3 relative lg:bg-white lg:pt-16">
      <button class="svg-container focus:outline-none lg:hidden" @click="$emit('close')">
        <OSvg svg="arrow-left" class="fill-white" />
      </button>
      <div class="text-center lg:text-left lg:flex lg:items-center">
        <span class="ota-p16 font-semibold text-white lg:text-gray-600 cart-title" v-text="title" />
        <button class="hidden lg:block lg:ml-auto lg:pr-10 lg:pl-5 lg:cursor-pointer focus:outline-none" @click="$emit('close')">
          <OSvg svg="cross" class="fill-gray-400" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'
import { CartTypes } from '@/enums/webshop'

export default {
  name: 'WebshopCartHeader',
  components: { OSvg },
  props: {
    title: {
      type: String,
      default: ''
    },
    cart: {
      type: Array,
      default: () => ([])
    },
    type: {
      type: String,
      default: CartTypes.Cart,
      validator: value => Object.keys(CartTypes).includes(value)
    }
  },
  computed: {
    isCheckoutType () {
      return this.type === CartTypes.Checkout
    }
  }
}
</script>

<style lang="postcss" scoped>
.svg-container {
  @apply py-2 absolute top-0 bottom-0 m-auto;
  width: 1.6rem;
  height: 3.2rem;
  left: 2.6rem;

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
}

@screen lg {
  .cart-title {
    @apply pl-10;
    font-size: 26px;
    font-weight: 600;
  }
}
</style>
